// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCHTjyQKgvjbZU7mo_YdE9B7FJMDgrNLOs",
  authDomain: "jamske-b4ec8.firebaseapp.com",
  projectId: "jamske-b4ec8",
  storageBucket: "jamske-b4ec8.appspot.com",
  messagingSenderId: "831545860032",
  appId: "1:831545860032:web:e3cf51f3defc379bfb3225",
  measurementId: "G-MB0VD0C4WD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Messaging service
export const messaging = getMessaging(app);